export enum AccountType {
	NORMAL = 'normal',
	GUEST = 'guest',
	ANONYMOUS = 'anonymous',
}

export type KnownAccount = {
	id: string;
	name: string;
	avatarURL: string;
	accountType: AccountType.GUEST | AccountType.NORMAL;
	isDeactivated?: boolean;
	lastViewedAt?: string;
	localIds?: string[];
	isEngaged: boolean | null;
	/**
	 * True when the underlying account is an app/agent-backed principal
	 * (analytics `permissionType === APP`). Optional and additive: existing
	 * consumers that don't distinguish agents can ignore it. Only reliably set
	 * for accounts returned by `contentAnalyticsViewsByUser` (i.e. viewers) —
	 * non-viewers are classified separately (see `useMentionedAgents`).
	 */
	isAgent?: boolean;
};

export type AnonymousAccount = {
	id: null;
	name: null;
	avatarURL: null;
	accountType: AccountType.ANONYMOUS;
	isDeactivated?: false;
	lastViewedAt?: string;
	localIds?: string[];
	isEngaged: boolean | null;
};

export type Account = KnownAccount | AnonymousAccount;
